import { permission } from "./permission";
import { constantRouterMap } from "./basics.router";
import { createRouter, createWebHashHistory } from "vue-router";
import { RouterObj } from "@/types/api/login";
import useActiveTab from "@/hooks/useActiveTab";
import useGlobalEventBus from "@/hooks/useGlobalEventBus";
import store from "@/store";
import queryString from "query-string";
import type { AppCollection } from "@/constant";
import { APP_LIST } from "@/configs/childAppConfig";
import { checkIsPageAuth } from "../handles/router";

const EventBus = useGlobalEventBus();

export type RouteInfoType = {
  path: string;
  params: Record<string, any>;
  query: Record<string, any>;
};

// 实例化路由
const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRouterMap,
});
export function handleUrl(url: string) {
  let tepUrl = decodeURIComponent(url);
  if (tepUrl.indexOf("#") >= 0) {
    tepUrl = tepUrl.replace(/#/g, "%23");
  }
  return tepUrl;
}
export const getChildAppFullPath = (router: RouterObj, app: string) => {
  const appPath = APP_LIST.find((item) => item.sysCode === app)?.path;
  const path = appPath
    ? `/#${router.path || router.query || "control-center"}`
        .replace(/^\/+|\/+$/g, "")
        .replace(/\/+/g, "/")
    : router.path;
  const qs = { [app]: path };
  return `${appPath}?${queryString.stringify(qs)}`;
};

export const openChildRoute = (
  _router: RouterObj,
  app: AppCollection,
  bubble = false,
  isSingle = true,
  changeType = "add"
) => {
  let fullPath = getChildAppFullPath(_router, app);
  const [_activeKey, setActiveKey] = useActiveTab();
  //eslint-disable-next-line no-console
  // console.log(_activeKey, "_activeKey");
  const isPathAuth = checkIsPageAuth(app, _router.path);
  if(!isPathAuth){
    router.push('/403')
    return 
  }

  if (_router.params && Object.keys(_router.params).length) {
    const key = Object.keys(_router.params)[0];
    fullPath = fullPath + "/" + _router.params[key];
    _router.path += "/" + _router.params[key];
  }
  // eslint-disable-next-line no-console
  // console.log(bubble, "bubblebubble");
  !bubble &&
    EventBus.$registerMountedQueue(
      app,
      "CHANGE_ROUTE",
      { path: _router.path, query: _router.query, app, hash: _router.path, changeType },
      store
    );
  // Handle query parameters properly
  const finalPath = _router.query
    ? `${fullPath}&${queryString.stringify(
        _router.query as unknown as Record<string, any>
      )}`
    : fullPath;
  try {
    if (!isSingle) {
      fullPath = finalPath;
    }
    const tepFinalPath = handleUrl(finalPath);
    const newFullPath = handleUrl(fullPath);
    const item = {
      path: fullPath,
      app: app,
      childAppPath: _router.path, //子应用原始路径
      fullPath: decodeURIComponent(newFullPath), //完整路径有参数
      name: _router?.name || "",
      title: _router?.name,
      subName: _router?.subName || "",
      query: _router?.query,
      params:_router?.params
    }
    store.commit("tabs/setList", item);
    sessionStorage.setItem("CURRENT_TAB", JSON.stringify(item));
    router.push(tepFinalPath);
    setActiveKey(decodeURIComponent(newFullPath));
    return;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("路由跳转错误:", error);
  }
  const newFullPath = handleUrl(fullPath);
  setActiveKey(decodeURIComponent(newFullPath));
};

export const closeChildRoute = (pagePath: string, app: AppCollection) => {
  const appPath = APP_LIST.find((item) => item.sysCode === app)?.path;
  const fullPath = `${appPath}?${queryString.stringify({
    [app]: "#" + pagePath,
  })}`;
  store.commit("tabs/delList", decodeURIComponent(fullPath));
};

permission(router);

export default router;
